import { API, graphqlOperation, Storage } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import EquipmentTypeDocumentForm from "components/equipmentTypes/documents/EquipmentTypeDocumentForm";
import { updateEquipmentTypeDocument } from "graphql/mutations";
import { getEquipmentTypeDocument } from "graphql/queries";
import LoaderFullScreen from "components/utils/LoaderFullScreen";

const EquipmentTypeDocumentUpdateForm = ({ equipmentTypeDocumentId, onSuccess }) => {
  const navigate = useNavigate();
  const [equipmentTypeDocument, setEquipmentTypeDocument] = useState();
  const [loading, setLoading] = useState(false);

  async function onSubmit(valuesParam) {
    try {
      setLoading(true);

      const { fileName, fileSrc: fileObj } = valuesParam;
      let fileSrc = equipmentTypeDocument.fileSrc;

      if (fileObj !== equipmentTypeDocument.fileSrc) {
        fileSrc = `${fileObj.name
          .split(".")
          .slice(0, -1)
          .join(".")}_${Date.now()}.${fileObj.name.split(".").slice(-1)[0]}`;

        await Storage.put(`equipment-types/${fileSrc}`, fileObj, {
          contentType: fileObj.type,
          level: "public",
        });

        await Storage.remove(`equipment-types/${equipmentTypeDocument.fileSrc}`, {
          level: "public",
        });
      }

      await API.graphql({
        query: updateEquipmentTypeDocument.replaceAll("__typename", ""),
        variables: {
          input: {
            id: equipmentTypeDocumentId,
            fileName,
            fileSrc,
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/equipment-types");
    } catch (err) {
      toast.error(strings.responses[err]);
    } finally {
      setLoading(false);
    }
  }

  async function fetchEquipmentTypeDocument(id) {
    try {
      const equipmentTypeDocumentData = await API.graphql(
        graphqlOperation(getEquipmentTypeDocument, { id })
      );
      const equipmentTypeDocumentItem =
        equipmentTypeDocumentData.data.getEquipmentTypeDocument;
      if (!equipmentTypeDocumentItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/equipment-types");
        return;
      }
      setEquipmentTypeDocument({
        ...equipmentTypeDocumentItem,
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchEquipmentTypeDocument(equipmentTypeDocumentId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [equipmentTypeDocumentId]);

  if (!equipmentTypeDocument) return <Loader />;

  return (
    <div>
      <EquipmentTypeDocumentForm
        onSubmit={onSubmit}
        type="update"
        initialValues={equipmentTypeDocument}
      />
      {loading && <LoaderFullScreen />}
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Documento de Equipo",
    successUpdated: "Documento de Equipo actualizado con éxito",
    responses: {
      errorFetch: "Error al consultar el documento de equipo",
    },
  },
});

export default EquipmentTypeDocumentUpdateForm;
